import { FC, useState } from "react";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";

import ItemPreview from "./ItemPreview";
import { IUploadFile } from "./interface";

import { Spinner } from "../index";
import { DeleteFileIco, DeletedItemIco } from "../../assets/customIcons";
import styles from "./UploadFile.module.scss";

interface IUploadItemPreview {
  file: IUploadFile;
  removeFile?: (index) => void;
  restoreFile?: (index) => void;
  canDelete?: boolean;
  disabled?: boolean;
}

const UploadItemPreview: FC<IUploadItemPreview> = ({
  file,
  removeFile,
  restoreFile,
  disabled,
  canDelete = true,
}) => {
  const [open, setOpen] = useState(false);
  const { status, name, originalName, deleted, loading, error } = file;
  const fileName = name || originalName;

  return (
    <Tooltip
      placement="top"
      title={
        deleted
          ? "Восстановить файл"
          : error
          ? error?.message || "Ошибка загрузки файла"
          : fileName
      }
      color="white"
      overlayInnerStyle={{ color: "#5F7380", fontSize: "14px" }}
      open={open}
    >
      <div
        className={classnames(styles.uploadPreview, {
          [styles.uploadPreviewRemoved]: deleted,
          [styles.uploadError]: error,
        })}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={() => setOpen(false)}
      >
        {loading || status === "uploading" ? (
          <Spinner />
        ) : ((canDelete || !deleted) && !disabled) || error ? (
          <>
            <DeleteFileIco
              onClick={() => removeFile(file)}
              className={classnames(styles.uploadPreviewRemoveButton, {
                [styles.uploadError]: error,
              })}
            />
            {deleted && (
              <DeletedItemIco
                onClick={() => restoreFile(file)}
                className={classnames(styles.uploadPreviewRestoreButton, {
                  [styles.uploadError]: error,
                })}
              />
            )}
            <ItemPreview file={file} />
          </>
        ) : (
          <ItemPreview file={file} />
        )}
      </div>
    </Tooltip>
  );
};

export default observer(UploadItemPreview);
